class PvRawOfferModel {

    constructor({ offer, roofSheathings, priceFactors, userExtraPremium, offerBasis,
        samplePvOfferIndex, allBatteries, allSolarPanels, allInverters, extraCosts })
    {
        this.offer = offer
        this.samplePvOfferIndex = samplePvOfferIndex
        this.allBatteries = allBatteries
        this.allInverters = allInverters

        if (extraCosts === undefined) {
            extraCosts = []
        }

        this.$data = {
            solarPanelSelected: allSolarPanels.find((panel) => {
                return panel.id === offer.solar_panel_id;
            }),
            inverterSelected: allInverters.find((inverter) => {
                return inverter.id === offer.inverter_id;
            }),
            pvSolarPanelsNumber: offer.solarPanelsNumber,
            forceCommissionVisibility: offer.extras.meta.forceCommissionVisibility,
            batterySelected: allBatteries.find((battery) => {
                return battery.id === offer.battery_id;
            }),
            strings: offer.strings,
            discount: parseFloat(offer.discount) > 0 ? parseFloat(offer.discount) : 0,
            optimizersNumber: offer.optimizersNumber,
            inverterQuantity: offer.inverter_quantity,
            taxIncentivePercent: 0.17,
            offerBasis: offerBasis,
            extraCosts: extraCosts,
        }

        this.priceFactors = Object.assign(
            {},
            priceFactors.map((o) => {
                let key = o.name_as_variable;
                let value = parseFloat(o.price);

                return { [key]: value };
            })
        )

        this.userExtraPremium = userExtraPremium

        this.roofSheathings = roofSheathings

    }

    changeSolarPanel(solarPanel)
    {

    }

    changeBattery(battery)
    {

    }

    changeInverter(inverter)
    {

    }

    getMountingMaterialPrice()
    {
        return this.offer.extras.pricing.mountingMaterial;
    }

    getInstallerCommissionPrice()
    {
        return this.offer.extras.pricing.installerCommission
    }

    getDcBoxPrice()
    {
        return this.offer.extras.pricing.dcBoxPrice
    }

    getOptimizersPrice()
    {
        return this.offer.extras.pricing.optimizers
    }

    // -------

    batteriesCompatible()
    {
        return []

        // if (this.$data.inverterSelected.is_hybrid) {
        //     return this.allBatteries.filter((bat) => {
        //         return JSON.parse(
        //             this.$data.inverterSelected.compatible_battery_brands
        //         ).includes(bat.brand);
        //     });
        // } else {
        //     // this.batterySelected = ref(null);
        //     return null;
        // }
    }

    totalNetCosts()
    {
        return this.offer.extras.pricing.totalNetCosts;
    }

    minimumCompanyMargin()
    {
        return this.offer.extras.pricing.minimumCompanyMargin
    }

    minimumSellingPriceNet()
    {
        return this.offer.extras.pricing.minimumSellingPriceNet
    }

    baseMargin()
    {
        return this.offer.extras.pricing.baseMargin;
    }

    totalMarkup()
    {
        return this.totalPriceNet() - this.minimumSellingPriceNet()
    }

    newSalesCommission()
    {
        return parseFloat(this.offer.salesCommission)
    }

    newCompanyProfit()
    {
        return this.offer.extras.pricing.newCompanyProfit
    }

    totalPriceNet()
    {
        return this.offer.sellingPriceNet
    }

    baseSellingPriceNet()
    {
        return parseFloat(this.offer.baseSellingPriceNet)
    }

    legacySalesCommission()
    {
        return this.offer.extras.pricing.legacySalesCommission
    }

    legacyCompanyProfit()
    {
        return this.offer.extras.pricing.legacyCompanyProfit
    }

    installationSize()
    {
        return this.offer.extras.pricing.installationSize
    }

    suitableInverters()
    {
        return this.allInverters.filter((inverter) => {
            return (
                parseFloat(inverter.max_kwp) * this.$data.inverterQuantity >
                this.installationSize()
            );
        });
    }

    areOptimizersAvailable()
    {
        if (this.$data.inverterSelected) {
            return (
                this.$data.inverterSelected.brand === "Huawei" ||
                this.$data.inverterSelected.brand === "SolarEdge"
            );
        }
        return true;
    }

    extras()
    {
        const extras = {};
        const pricing = {};
        const meta = {};
        const extraPrices = this.prices();

        for (let x in extraPrices) {
            pricing[x] = !isNaN(extraPrices[x]) ? extraPrices[x] : 0;
        }

        pricing["totalNetCosts"] = this.totalNetCosts();
        pricing["minimumCompanyMargin"] = this.minimumCompanyMargin();
        pricing["baseMargin"] = this.baseMargin();
        pricing["minimumSellingPriceNet"] = this.minimumSellingPriceNet();
        pricing["totalMarkup"] = this.totalMarkup();
        pricing["newCompanyProfit"] = this.newCompanyProfit();
        pricing["legacySalesCommission"] = this.legacySalesCommission();
        pricing["legacyCompanyProfit"] = this.legacyCompanyProfit();
        pricing["installationSize"] = this.installationSize();
        pricing["totalPriceWithMarginWithVAT"] =this.totalPriceWithMarginWithVAT();
        pricing["battery"] = this.$data.batterySelected ? this.$data.batterySelected.buying_price : null;

        meta["samplePvOfferIndex"] = this.samplePvOfferIndex;
        meta["lightningProtection"] = this.$data.offerBasis.lightning_protection;
        meta["diggingLength"] = this.$data.offerBasis.digging_length;
        meta["forceCommissionVisibility"] = this.$data.forceCommissionVisibility;

        extras["pricing"] = pricing;
        extras["meta"] = meta;
        extras["public"] = true;

        return extras;
    }


    prices()
    {
        return {
            solarPanels: this.offer.extras.pricing.solarPanels,
            inverter: this.offer.extras.pricing.inverter * this.offer.inverter_quantity,
            mountingMaterial: this.offer.extras.pricing.mountingMaterial,
            installerCommission: this.offer.extras.pricing.installerCommission,
            cablesAndAccessories: this.offer.extras.pricing.cablesAndAccessories,
            acBoxPrice: this.offer.extras.pricing.acBoxPrice,
            dcBoxPrice: this.offer.extras.pricing.dcBoxPrice,
            optimizers: this.offer.extras.pricing.optimizers,
            digging: this.offer.extras.pricing.digging,
            lift: this.offer.extras.pricing.lift,
            insurance: this.offer.extras.pricing.insurance,
            grounding: this.offer.extras.pricing.grounding,
            fireProtection: this.offer.extras.pricing.fireProtection,
            stuckTiles: this.offer.extras.pricing.stuckTiles,
            snowGuardRemoval: this.offer.extras.pricing.snowGuardRemoval,
            lightningRodRemoval: this.offer.extras.pricing.lightningRodRemoval,
            transport: this.offer.extras.pricing.transport,
            referral: this.offer.extras.pricing.referral,
            // battery: this.offer.extras.pricing.battery
        };
    }

    totalPriceWithMarginWithVAT()
    {
        return this.offer.extras.pricing.totalPriceWithMarginWithVAT
    }

    batteryCommissions()
    {
        const rate = 0.1666;
        return {
            sales: !this.$data.batterySelected
                ? 0
                : (this.$data.batterySelected.selling_price -
                    this.$data.batterySelected.buying_price) *
                rate,
            company: !this.$data.batterySelected
                ? 0
                : (this.$data.batterySelected.selling_price -
                    this.$data.batterySelected.buying_price) *
                (1 - rate),
        };
    }

    getSubsidy()
    {
        if (this.offer.extras.subsidies && this.offer.extras.subsidies[0]) {
            return this.offer.extras.subsidies[0]
        } else {
            return {"exists": false}
        }

    }

    getFinancing()
    {
        if (this.offer.extras.financing) {
            return this.offer.extras.financing
        } else {
            return {"available": false}
        }
    }

}

export default PvRawOfferModel
